export default class Donations {
    watchDonationFrequency() {
        const donationFrequency = document.querySelectorAll('input[name="donation_frequency"]');

        donationFrequency?.forEach((input) => {
            input.addEventListener('change', (event) => {
                const campaignSelectCF = document.getElementById('which_campaign_are_you_supporting?');
                const campaignSelectedCFOptions = campaignSelectCF?.querySelectorAll('option');
                if (campaignSelectCF) {
                    if (event.target.value === 'monthly') {
                        campaignSelectedCFOptions?.forEach((option) => {
                            if (option.value && option.value !== '7018a000000u0LfAAI') {
                                option.setAttribute('disabled', 'disabled');
                            } else if (option.value && option.value === '7018a000000u0LfAAI') {
                                option.setAttribute('selected', 'selected');
                            }
                        })
                    } else {
                        campaignSelectedCFOptions?.forEach((option) => {
                            if (option.value) {
                                option.removeAttribute('disabled');
                                option.removeAttribute('selected');
                            }
                        })
                    }
                }

            });
        })
    }
}